import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
export default function Overlay(props) {
    var show = props.show, onClose = props.onClose, children = props.children;
    return (_jsxs(Dialog, { open: show, onClose: onClose, transition: true, className: "fixed inset-0 z-10 flex items-center justify-center transition-opacity data-[closed]:opacity-0", children: [_jsx(DialogBackdrop, { className: "fixed inset-0 -z-10 bg-black/50" }), _jsx(DialogPanel, { className: "flex max-h-full max-w-full flex-col", children: children })] }));
}
